import { useState } from 'react';
import { isObjectEmpty } from '../../utils';

export type FormValidationType<T> = {
    value: T;
    isValid: boolean;
    isMandatory: boolean;
};

export function useFormValidationState<T>(
    initialValue: T,
    isMandatory: boolean = false,
    validate: (value: T) => boolean = () => true
): [FormValidationType<T>, (value: T) => void] {
    // If isMandatory and value is a string, also check if value is empty next to the arg validate() method
    const validateWithEmptyCheck = (value: T) => {
        if (!isMandatory) {
            return validate(value);
        }

        return !isObjectEmpty(value) && validate(value);
    };

    const [state, setState] = useState<FormValidationType<T>>({
        value: initialValue,
        isValid: validateWithEmptyCheck(initialValue),
        isMandatory
    });

    const updateValue = (value: T) => {
        setState({
            ...state,
            value,
            isValid: validateWithEmptyCheck(value)
        });
    };

    return [state, updateValue];
}
